import { createContext, PropsWithChildren, useContext } from 'react';
import { AttendeesApi } from './api/attendees';
import { BadgeInformation, Identifier } from './types';

type AttendeesContext = {
  getBadgeInformation: (attendeeId: Identifier) => Promise<BadgeInformation>;
};

const DEFAULT_CONTEXT: AttendeesContext = {
  getBadgeInformation: async (attendeeId) => {
    console.log('no such badge', attendeeId);
    throw new Error();
  },
};
const context = createContext(DEFAULT_CONTEXT);
export const useAttendees = () => useContext(context);

type ProvideAttendeesProps = {
  attendeesApi: AttendeesApi;
};

export const AttendeesProvider = ({
  attendeesApi: AttendeesApi,
  children,
}: PropsWithChildren<ProvideAttendeesProps>) => {
  const Attendees = {
    getBadgeInformation: AttendeesApi.getBadgeInformation,
  };
  return <context.Provider value={Attendees}>{children}</context.Provider>;
};
